module.exports = __webpack_public_path__ + "static/TabletHealth-8caf66946553ba6a93b970ecb8cfc371.png";